import SiderMenu from 'components/Main/SiderMenu'
import React from 'react'
import Footer from '../components/Footer'
import Header from './Header'

export default function MasterLayout(props) {
  return (
    <div className="flex flex-col bg-gray-300 min-h-screen flex-grow">
      <Header />
      <div className="flex-1 flex flex-row">
        <SiderMenu />
        <div className="p-0 w-full overflow-hidden" >{props.children}</div>
      </div>
      <Footer />
    </div>
  )
}
